export default __webpack_public_path__ + "static/media/ios.525edc76.svg";